import { useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { QuestionItem } from "@/components/QuestionItem";

export function QuestionInbox() {
  const { t } = useLang();
  const [items, setItems] = useState(null);
  useEffect(() => {
    const load = () => api.questions().then(setItems).catch(() => setItems([]));
    load();
    // AI sorting finishes a few seconds after a question arrives
    const later = () => setTimeout(load, 8000);
    window.addEventListener("questions-changed", load);
    window.addEventListener("questions-changed", later);
    return () => { window.removeEventListener("questions-changed", load); window.removeEventListener("questions-changed", later); };
  }, []);

  const fresh = items?.filter((q) => q.status !== "answered").length || 0;
  return (
    <div className="card" data-testid="question-inbox">
      <div className="donate-head"><Inbox size={18} /><div className="card-name">{t("Driver questions")}</div>
        {fresh > 0 && <span className="inbox-badge" data-testid="inbox-new-count">{fresh}</span>}</div>
      {items === null ? <div className="card-sub">…</div> : items.length === 0 ? (
        <div className="card-sub" data-testid="inbox-empty">{t("No questions yet.")}</div>
      ) : items.map((q) => (
        <QuestionItem key={q.id} q={q} t={t} onChange={(nq) => setItems((all) => all.map((x) => (x.id === nq.id ? nq : x)))} />
      ))}
    </div>
  );
}
